/* unplugin-vue-components disabled */import script from "./batch-unmaintain-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-unmaintain-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./batch-unmaintain-dialog.vue?vue&type=style&index=0&id=6eeaa5fa&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eeaa5fa"]])

export default __exports__